import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "estate-card__params" }
const _hoisted_2 = { class: "estate-card__param" }
const _hoisted_3 = {
  key: 0,
  class: "estate-card__param"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("m"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "estate-card__param"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("m"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "estate-card__param date" }
const _hoisted_10 = {
  key: 2,
  class: "estate-card__param gender"
}
const _hoisted_11 = {
  key: 3,
  class: "estate-card__param"
}
const _hoisted_12 = {
  key: 0,
  class: "estate-card__param"
}
const _hoisted_13 = {
  key: 1,
  class: "estate-card__param"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("m"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_15 = {
  key: 2,
  class: "estate-card__param"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("m"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 3,
  class: "estate-card__param"
}
const _hoisted_19 = {
  key: 4,
  class: "estate-card__param"
}
const _hoisted_20 = {
  key: 5,
  class: "estate-card__param"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SexIcon = _resolveComponent("SexIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isRoommate)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_ctx.ad.personCount), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdListItemParams.personCount')) + " /", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.ad.bedCount), 1)
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdListItemParams.bedCount')), 1)
          ]),
          (_ctx.ad.estateArea && !_ctx.isHouse)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("strong", null, [
                  _createTextVNode(_toDisplayString(_ctx.ad.estateArea), 1),
                  _hoisted_4
                ]),
                (!_ctx.compact)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.isHouse ? 'AdListItemParams.estateArea-house' : 'AdListItemParams.estateArea')), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.ad.usefulArea)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("strong", null, [
                  _createTextVNode(_toDisplayString(_ctx.ad.usefulArea), 1),
                  _hoisted_7
                ]),
                (!_ctx.compact)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('AdListItemParams.usefulArea')), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("strong", null, [
              (_ctx.ad.availableFrom)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.$filters.date(_ctx.ad.availableFrom, 'dd. MM.')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$filters.date(_ctx.ad.availableFrom, 'yyyy')), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('AdListItemParams.availableFrom-now')), 1)
                  ], 64))
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdListItemParams.availableFrom')), 1)
          ]),
          (!_ctx.compact)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_SexIcon, {
                    type: _ctx.ad.adSex
                  }, null, 8, ["type"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.ad.adSexTitle), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.compact)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.ad.adAgeTitle), 1),
                _createTextVNode(),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdListItemParams.age')), 1)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.ad.roomCount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.ad.roomCount), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdListItemParams.roomCount')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.ad.estateArea && !_ctx.isHouse)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("strong", null, [
                  _createTextVNode(_toDisplayString(_ctx.ad.estateArea), 1),
                  _hoisted_14
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.isHouse ? 'AdListItemParams.estateArea-house' : 'AdListItemParams.estateArea')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.ad.usefulArea)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("strong", null, [
                  _createTextVNode(_toDisplayString(_ctx.ad.usefulArea), 1),
                  _hoisted_16
                ]),
                (!_ctx.compact)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('AdListItemParams.usefulArea')), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.landArea)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("strong", null, [
                  _createTextVNode(_toDisplayString(_ctx.landArea), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdListItemParams.ares')), 1)
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdListItemParams.landArea')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isDeveloperProject)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.ad.adCount), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdListItemParams.adCount')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isDeveloperProject && _ctx.ad.maxFloor)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.ad.maxFloor), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdListItemParams.maxFloor')), 1)
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}